<template>
  <div id="Licence">
    <mu-flex class="index_block_1" id="section_1" direction="column" justify-content="between">
      <mu-container>
        <mu-row gutter>
          <mu-col :span="6" style="margin-top:245px;">
            <h1 class="top_title"> {{$t('index.importLicence')}}</h1>
            <mu-row gutter style="margin-top:36px;">
              <mu-form ref="licenceForm" :model="licenceForm"  label-width="100px">
                <mu-form-item label prop="lang">
                  <mu-flex justify-content="start" align-items="center" style="width: 100%">
                    <span>{{$t('login.locate')}}:</span>
                    <mu-menu :open.sync="openLang">
                      <mu-button color="primary" flat>
                        <img :src="selectLang.img" style="margin-right:6px;width:32px" />
                        {{selectLang.name}}
                      </mu-button>
                      <mu-list slot="content">
                        <mu-list-item
                            avatar
                            button
                            v-for="language in languages"
                            :key="language.key"
                            @click="changeLang(language)"
                        >
                          <mu-list-item-action>
                            <mu-avatar>
                              <img :src="language.img" />
                            </mu-avatar>
                          </mu-list-item-action>
                          <mu-list-item-title>{{language.name}}</mu-list-item-title>
                        </mu-list-item>
                      </mu-list>
                    </mu-menu>
                  </mu-flex>
                </mu-form-item>
                <mu-form-item  prop="licenceFile">
                  <mu-col :span="5" >
                    <el-upload
                        drag
                        :headers="headers"
                        :limit="1"
                        :action="uploadUrl"
                        :show-file-list="true"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleAvatarSuccess"
                        ref="uploadFile"
                        :auto-upload="false"
                        v-model="licenceFile"
                        :on-exceed="exceedFunction"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        {{$t('document.dragFilesHereOr')}}
                        <em>{{$t('document.clickUpload')}}</em>
                      </div>
                    </el-upload>
                    <mu-button color="primary" @click="save"  full-width>
                      <mu-icon value="file_upload" left></mu-icon>
                      {{$t('index.upload')}}
                    </mu-button>
                  </mu-col>
              <!--    <mu-col :span="5" v-if="showBtnEn">
                    <el-upload
                        drag
                        :headers="headers"
                        :limit="1"
                        :action="uploadUrl"
                        :show-file-list="true"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleAvatarSuccess"
                        ref="uploadFile"
                        :auto-upload="false"
                        v-model="licenceFile"
                        :on-exceed="exceedFunction"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        {{$t('document.dragFilesHereOr')}}
                        <em>{{$t('document.clickUpload')}}</em>
                      </div>
                    </el-upload>
                    <mu-button full-width color="primary" @click="save">
                      <mu-icon value="file_upload" left></mu-icon>
                      {{$t('index.upload')}}
                    </mu-button>
                  </mu-col>-->
                </mu-form-item>

              </mu-form>
            </mu-row>
          </mu-col>
          <mu-col :span="6" style="margin-top:84px;">
            <img src="/mdm/static/index/download_img.jpg" />
          </mu-col>
        </mu-row>
      </mu-container>
      <img src="/mdm/static/index/HedaerWave.png" style="width:100%;" />
    </mu-flex>
    <mu-flex class="index_block_6">
      <mu-container>
        <mu-flex align-items="center">
          <img
              src="/mdm/static/index/pic_footer_logo.png"
              v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'"
          />
          <img src="/mdm/static/index/pic_main_logo_blue_en.png" class="logo_img" v-else />
          <mu-flex direction="column">
            <span>{{$t('index.copyright')}}</span>
            <span>{{$t('index.Shaanxi')}}</span>
          </mu-flex>
        </mu-flex>
      </mu-container>
    </mu-flex>
  </div>
</template>
<script>
import store from "@/vuex/store";
import chineseFlag from "@/assets/image/chinese_flag.png";
import englishFlag from "@/assets/image/english_flag.png";
export default {
  name: "Licence",
  data() {
    return {
      licenceFile:[],
      uploadUrl: "",
      headers: {},
      licenceForm:{},
      selectLang: {},
      openLang: false,
      languages: [
        { key: "zh-CN", name: "简体中文", img: chineseFlag },
        { key: "en", name: "English", img: englishFlag }
      ],
    };
  },
  mounted() {
  this.uploadUrl = "/licence/upload?lang="+this.$store.state.lang;
    if (store.state.lang == "zh-CN" || store.state.lang == "zh") {
      this.selectLang = this.languages[0];
    } else {
      this.selectLang = this.languages[1];
    }
  },
  methods: {
    changeLang(locate) {
      this.selectLang = locate;
      if (locate.key == "zh-CN" || locate.key == "zh") {
        this.$i18n.locale = locate.key;
        store.commit("set_lang", locate.key);
      } else {
        this.$i18n.locale = "en";
        store.commit("set_lang", "en");
      }
      this.openLang = false;
    },
    exceedFunction(fileList) {
      if (fileList.length == 1) {
        this.$toast.warning(this.$t("appVersion.warning"));
      }
    },
    //删除上传文件列表的文件
    handleRemove() {
      this.licenceFile = {};
    },
    //上传文件时处理方法
    handleChange(file, fileList) {
      if(file.name.indexOf(".") == -1){
        this.$toast.warning(this.$t('common.uploadDir'));
        this.$refs.uploadFile.clearFiles();
        return;
      }
      if(file.name.length > 125){
        this.$toast.warning(this.$t('common.uploadName'));
        this.$refs.uploadFile.clearFiles();
        return;
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$toast.warning(this.$t('common.uploadDocumentSize'));
        this.licenceFile = ""
        this.$refs.uploadFile.clearFiles();
        return;
      }else{
        this.licenceFile = file;
        this.uploadFlag = true;
      }

    },
    handleAvatarSuccess(res, file) {

    },
    save(){
      let file = this.licenceFile.raw
      let formData = new FormData();
      formData.append("file",file);
      this.$axios({
        url: this.uploadUrl,
        data: formData,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        if(res.data.code == 200){
          //跳转到首页
          this.$router.go(-1);
          location.reload();
        }else if(res.data.code == 500){
          this.$toast.error(res.message);
        }else if(res.data.code == 513){
          this.$toast.error(this.$t('index.licenceHasExpired'));
        }
      })
    }
  }
};
</script>
<style scoped>
#Download {
  background: #ffffff;
  min-height: 100vh;
}
.top_nav {
  width: 100%;
  position: fixed;
  overflow: hidden;
}
.top_nav .nav_buton {
  color: #333333 !important;
  font-weight: 600;
}
.logo_img {
  height: 34px;
}
.index_block_1 {
  width: 100%;
  height: calc(100vh - 128px);
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
}
.index_block_1 .top_title {
  font-weight: 400;
  columns: #333333;
  line-height: 59px;
  font-size: 42px;
}
.index_block_1 .top_sub_title {
  font-weight: 400;
  columns: #888888;
  line-height: 24px;
  font-size: 17px;
}
.index_block_1 .right_img_1 {
  position: absolute;
  top: 480px;
  left: 64px;
  transform: rotate(-12deg);
}
.index_block_1 .right_img_2 {
  position: absolute;
  top: 128px;
  right: -420px;
  transform: rotate(-12deg);
}
.index_block_6 {
  padding-top: 54px;
  padding-bottom: 38px;
}
.index_block_6 span {
  margin-left: 26px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(107, 124, 147, 1);
  line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/views/licence/index.vue